<form [formGroup]="formGroup">
  <div formArrayName="skill">
    <div class="card-data">
      <h4>
        {{ "Skills" | translate }}
      </h4>
      <div
        class="row align-items-end"
        *ngFor="let skill of skills.controls; let i = index"
      >
        <div class="col p-0 p-md-auto">
          <label>{{ "Skill" | translate }}</label>

          <input
            type="text"
            [formControlName]="i"
            placeholder="{{ 'Skill' | translate }}"
          />
        </div>
        <!-- <div class="col">
      <label>{{ "Description" | translate }}</label>

      <input
        type="text"
        placeholder="{{ 'Enter your description' | translate }}"
      />
    </div> -->
        <i
          class="col-auto bi bi-trash3 delete-icon"
          *ngIf="this.skills.length > 1"
          (click)="removeSkill(i)"
        ></i>
      </div>
      <button class="border-button" (click)="addSkill()">
        {{ "Add New" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>
  </div>

  <div formArrayName="course">
    <div class="card-data">
      <h4>
        {{ "Courses" | translate }}
      </h4>
      <div
        class="row align-items-end"
        *ngFor="let course of courses.controls; let i = index"
      >
        <div class="col p-0 p-md-auto">
          <label>{{ "Course" | translate }}</label>

          <input
            type="text"
            [formControlName]="i"
            placeholder="{{ 'Course Name' | translate }}"
          />
        </div>

        <i
          class="col-auto bi bi-trash3 delete-icon"
          *ngIf="courses.length > 1"
          (click)="removeCourse(i)"
        ></i>
      </div>
      <button class="border-button" (click)="addcourse()">
        {{ "Add New" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>
  </div>
  <div formArrayName="project">
    <div class="card-data">
      <h4>
        {{ "Projects" | translate }}
      </h4>
      <div
        class="row align-items-end"
        *ngFor="let project of projects.controls; let i = index"
      >
        <div class="col p-0 p-md-auto">
          <label>{{ "Project" | translate }}</label>

          <input
            type="text"
            [formControlName]="i"
            placeholder="{{ 'Project Name' | translate }}"
          />
        </div>

        <i
          class="col-auto bi bi-trash3 delete-icon"
          *ngIf="projects.length > 1"
          (click)="removeProject(i)"
        ></i>
      </div>
      <button class="border-button" (click)="addProject()">
        {{ "Add New" | translate }}
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>
  </div>
  <div class="card-data" formArrayName="certification">
    <h4>
      {{ "Certificates" | translate }}
    </h4>
    <div
      class="row align-items-end"
      *ngFor="let certificat of certificates.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="col-6 col-sm">
        <label>{{ "Certificate Name" | translate }}</label>
        <input
          type="text"
          formControlName="name"
          placeholder="{{ 'Certificate Name' | translate }}"
        />
      </div>
      <div class="col-6 col-sm p-0 p-md-auto">
        <label>{{ "Organization Name" | translate }}</label>

        <input
          type="text"
          formControlName="organization"
          placeholder="{{ 'Enter organization name' | translate }}"
        />
      </div>
      <div class="col-6 col-sm">
        <label>{{ "Date" | translate }}</label>

        <input
          type="date"
          formControlName="date"
          placeholder="{{ 'Select date' | translate }}"
        />
      </div>
      <i
        class="col-auto bi bi-trash3 delete-icon"
        *ngIf="certificates.length > 1"
        (click)="removeCertificat(i)"
      ></i>
    </div>
    <button class="border-button" (click)="addCertificat()">
      {{ "Add New" | translate }}
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>

  <div class="card-data" formArrayName="languages">
    <h4>
      {{ "Languages" | translate }}
    </h4>

    <div
      class="row align-items-end"
      *ngFor="let lange of languages.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="col p-0 p-md-auto">
        <label>{{ "Language" | translate }}</label>
        <input
          type="text"
          formControlName="name"
          placeholder="{{ 'Select Language' | translate }}"
        />
      </div>
      <div class="col">
        <label>{{ "Level" | translate }}</label>

        <p-dropdown
          [options]="'LANGUAGE_LEVELS' | translate"
          [placeholder]="'Select Level' | translate"
          formControlName="level"
        />
      </div>
      <i
        class="col-auto bi bi-trash3 delete-icon"
        *ngIf="this.languages.length > 1"
        (click)="removeLanguage(i)"
      ></i>
    </div>

    <button class="border-button" (click)="addLanguage()">
      {{ "Add New" | translate }}
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>
  <div class="next-container px-4">
    <button type="button" class="border-button m-3" (click)="onPrevious()">
      {{ "Back" | translate }}
    </button>
    <button type="button" class="gradient-button m-3" (click)="onNext()">
      {{ "Finish" | translate }}
    </button>
  </div>
</form>
